import { useTranslation } from "react-i18next";
import { Field, Input, Select, tx } from "@/components/ui";
import { usePalette } from "@/components/FilterBar";

type Props = { brandId: string; entity: "appointments" | "customers"; values: Record<string, unknown>; onChange: (v: Record<string, unknown>) => void; className?: string };

/** Inputs for every active custom field of a brand (palette entries flagged `custom`). Keys are stored without the `custom.` prefix. */
export function CustomFieldInputs({ brandId, entity, values, onChange, className }: Props) {
  const { i18n } = useTranslation();
  const palette = usePalette(brandId, entity);
  const defs = (palette.data?.fields ?? []).filter((x) => x.custom);
  if (defs.length === 0) return null;
  const set = (k: string, v: unknown) => onChange({ ...values, [k]: v });
  return (
    <div className={className ?? "rounded-lg bg-gray-50 p-2 grid grid-cols-2 gap-2"}>
      {defs.map((d) => { const k = d.field.slice(7); const v = values[k]; return (
        <Field key={d.field} label={tx(d.label, i18n.language)}>
          {d.type === "bool" ? <input type="checkbox" checked={!!v} onChange={(e) => set(k, e.target.checked)} />
            : d.type === "select" ? <Select value={String(v ?? "")} onChange={(e) => set(k, e.target.value)}><option value="">—</option>{d.options?.map((o) => <option key={o} value={o}>{o}</option>)}</Select>
            : <Input type={d.type === "number" ? "number" : d.type === "date" ? "date" : "text"} value={String(v ?? "")} onChange={(e) => set(k, e.target.value)} />}
        </Field>); })}
    </div>
  );
}
